export default __webpack_public_path__ + "3a5b822a133f1f0b419acac335e0c976.png";